export default {
    BASE_URL: '/sms/reg',
    api: [
        {
            name: 'send',
            desc: '发送短信',
            method: 'POST',
            path: 'send'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/api/pub/sms/register.js